import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { stopCameraData } from '../redux/actions/CameraActions';
import './VideoModal.css';
import { baseURL } from '../axios';
import CPPlusLive from './CPPlusLive';

const VideoModal = ({
  show,
  onHide,
  cameraData,
  title = "Live Camera Feed"
}) => {
  const dispatch = useDispatch();
  const { AuthReducer: { auth } } = useSelector((state) => state);

  const handleClose = () => {
    if (cameraData?.id && auth?.accessToken) {
      dispatch(stopCameraData(auth?.accessToken, cameraData.id));
    }
    onHide();
  };

  const streamUrl = cameraData?.id
    ? `${baseURL}/streams/cam_${cameraData.id}.m3u8`
    : null;

  const liveCameraData = cameraData
    ? { id: cameraData.id, name: cameraData.cameraName || cameraData.name || title }
    : null;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      className="video-modal"
      backdrop="static"
    >
      <div className="video-modal-content">
        {/* TV Frame Header */}
        <div className="tv-frame-header">
          <div className="tv-brand">
            <div className="tv-logo">
              <i className="mdi mdi-television"></i>
              <span>PHED Rural Monitor</span>
            </div>
            <div className="tv-status">
              <div className="status-indicator">
                <div className="status-dot"></div>
                <span>LIVE</span>
              </div>
            </div>
          </div>
          <Button
            variant="outline-light"
            size="sm"
            onClick={handleClose}
            className="tv-close-btn"
          >
            <i className="mdi mdi-close"></i>
          </Button>
        </div>

        {/* TV Screen - CPPlusLive for video playback */}
        <div className="tv-screen">
          <div className="screen-border">
            <div className="video-container">
              {streamUrl && liveCameraData ? (
                <CPPlusLive
                  title={title}
                  checkOtherOptions={false}
                  showControls
                  cameraData={liveCameraData}
                  streamUrl={streamUrl}
                />
              ) : (
                <div className="video-error p-4 text-center text-white">
                  Camera ID not available for video.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default VideoModal;